import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NamObjectTemplate } from '../../../model/nam-object-template.interface';
@Component({
  selector: 'app-object-template',
  templateUrl: './object-template.component.html',
  styleUrls: ['./object-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectTemplateComponent {
  @Output()
  selectObjectTemplateEvent: EventEmitter<NamObjectTemplate> = new EventEmitter();

  private _objectTemplate: NamObjectTemplate;
  @Input()
  get objectTemplate(): NamObjectTemplate {
    return this._objectTemplate;
  }
  set objectTemplate(objectTemplate: NamObjectTemplate) {
    this._objectTemplate = (!!objectTemplate && objectTemplate) || null;
  }

  @Input()
  selectedObjectTemplate: NamObjectTemplate;

  shadow: boolean = false;

  onSelectObjectTemplate(objectTemplate) {
    this.selectObjectTemplateEvent.emit(objectTemplate);
  }

  changeStyle(event) {
    this.shadow = event.type === 'mouseover';
  }
}
